module.exports = __webpack_public_path__ + "static/media/cert_149.547518d6.jpg";